var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex"},[(_vm.toolPlacementIcon)?_c('div',{staticClass:"pr-2"},[_c('SIcon',{attrs:{"name":_vm.toolPlacementIcon}})],1):_vm._e(),_c('h1',{staticClass:"med",class:{ 'first-letter-uppercase': _vm.toolPlacementIcon }},[_vm._v(_vm._s(_vm.toolPlacementTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }